import React from 'react';
import './SecurityPolicy.css';

function SecurityPolicy() {
  return (
    <div className="bao-mat-policy">
      <h2>Chính Sách Bảo Mật Thông Tin</h2>
      <p>
        HustLaptop cam kết sẽ bảo mật những thông tin mang tính riêng tư của bạn. Bạn vui lòng đọc bản “Chính sách bảo mật” dưới đây để hiểu hơn những cam kết mà chúng tôi thực hiện, nhằm tôn trọng và bảo vệ quyền lợi của người truy cập.
      </p>

      <h3>1. Mục đích và phạm vi thu thập</h3>
      <p>
        Để truy cập và sử dụng một số dịch vụ tại HustLaptop, bạn có thể sẽ được yêu cầu đăng ký với chúng tôi thông tin cá nhân (Email, Họ tên, Số điện thoại liên lạc…). Mọi thông tin khai báo phải đảm bảo tính chính xác và hợp pháp. HustLaptop không chịu mọi trách nhiệm liên quan đến pháp luật của thông tin khai báo.
      </p>
      <p>
        Chúng tôi cũng có thể thu thập thông tin về số lần viếng thăm, bao gồm số trang bạn xem, số liên kết bạn click và những thông tin khác liên quan đến việc kết nối đến website HustLaptop. Chúng tôi cũng thu thập các thông tin mà trình duyệt web (Browser) bạn sử dụng mỗi khi truy cập vào HustLaptop, bao gồm: địa chỉ IP, loại Browser, ngôn ngữ sử dụng, thời gian và những địa chỉ mà Browser truy xuất đến.
      </p>

      <h3>2. Phạm vi sử dụng thông tin</h3>
      <p>
        HustLaptop thu thập và sử dụng thông tin cá nhân bạn với mục đích phù hợp và hoàn toàn tuân thủ nội dung của “Chính sách bảo mật” này. Khi cần thiết, chúng tôi có thể sử dụng những thông tin này để liên hệ trực tiếp với bạn dưới các hình thức như: gửi thư ngỏ, đơn đặt hàng, thư cảm ơn, SMS, thông tin về kỹ thuật và bảo mật…
      </p>

      <h3>3. Thời gian lưu trữ thông tin</h3>
      <p>
        Dữ liệu cá nhân của thành viên sẽ được lưu trữ cho đến khi có yêu cầu hủy bỏ hoặc tự thành viên đăng nhập và thực hiện hủy bỏ. Còn lại trong mọi trường hợp, thông tin cá nhân thành viên sẽ được bảo mật trên máy chủ của HustLaptop.
      </p>

      <h3>4. Địa chỉ của đơn vị thu thập và quản lý thông tin cá nhân</h3>
      <p>
        Công Ty Cổ Phần HustLaptop<br />
        Địa chỉ đăng ký kinh doanh: Số 1 Tạ Quang Bửu <br />
        Văn phòng: TP Hà Nội<br />
        Điện thoại văn phòng: 09182931031
      </p>

      <h3>5. Phương tiện và công cụ để người dùng tiếp cận và chỉnh sửa dữ liệu cá nhân</h3>
      <p>
        Hiện website chưa triển khai trang quản lý thông tin cá nhân của thành viên, vì thế việc tiếp cận và chỉnh sửa dữ liệu cá nhân dựa vào yêu cầu của khách hàng bằng cách hình thức sau:
      </p>
      <ul>
        <li>
          Gọi điện thoại đến tổng đài chăm sóc khách hàng <strong>1800 9999 </strong>, bằng nghiệp vụ chuyên môn xác định thông tin cá nhân và nhân viên tổng đài sẽ hỗ trợ chỉnh sửa thay người dùng.
        </li>
        <li>
          Để lại bình luận hoặc gửi góp ý trực tiếp từ website HustLaptop, quản trị viên kiểm tra thông tin và xem xét nội dung bình luận có phù hợp với pháp luật và chính sách của HustLaptop.
        </li>
      </ul>

      <h3>6. Cam kết bảo mật thông tin cá nhân khách hàng</h3>
      <ul>
        <li>
          Thông tin cá nhân của thành viên trên HustLaptop được HustLaptop cam kết bảo mật tuyệt đối theo chính sách bảo vệ thông tin cá nhân của HustLaptop. Việc thu thập và sử dụng thông tin của mỗi thành viên chỉ được thực hiện khi có sự đồng ý của khách hàng đó, trừ những trường hợp pháp luật có quy định khác.
        </li>
        <li>
          Không sử dụng, không chuyển giao, cung cấp hay tiết lộ cho bên thứ ba nào về thông tin cá nhân của thành viên khi không có sự cho phép đồng ý từ thành viên.
        </li>
        <li>
          Trong trường hợp máy chủ lưu trữ thông tin bị hacker tấn công dẫn đến mất mát dữ liệu cá nhân thành viên, HustLaptop sẽ có trách nhiệm thông báo vụ việc cho cơ quan chức năng điều tra xử lý kịp thời và thông báo cho thành viên được biết.
        </li>
        <li>
          Bảo mật tuyệt đối mọi thông tin giao dịch trực tuyến của thành viên bao gồm thông tin hóa đơn kế toán chứng từ số hóa tại khu vực dữ liệu trung tâm an toàn cấp 1 của HustLaptop.
        </li>
      </ul>

      <h3>7. Quy định bảo mật</h3>
      <ul>
        <li>
          Thông tin tài chính của khách hàng sẽ được bảo vệ trong suốt quá trình giao dịch bằng giao thức SSL 256-bit (Secure Sockets Layer).
        </li>
        <li>
          Mật khẩu sử dụng một lần (OTP) được gửi qua SMS để đảm bảo việc truy cập tài khoản được xác thực.
        </li>
        <li>
          Các nguyên tắc và quy định bảo mật thông tin trong ngành tài chính ngân hàng theo quy định của Ngân hàng nhà nước Việt Nam.
        </li>
      </ul>

      <h3>8. Làm cách nào để yêu cầu xóa dữ liệu?</h3>
      <p>
        Bạn có thể gửi yêu cầu xóa dữ liệu qua email Trung tâm hỗ trợ của chúng tôi: <strong>hustlaptop@hust.com.vn</strong>. Vui lòng cung cấp càng nhiều thông tin càng tốt về dữ liệu nào bạn muốn xóa. Yêu cầu sẽ được chuyển đến nhóm thích hợp để đánh giá và xử lý. Chúng tôi sẽ liên hệ từng bước để cập nhật cho bạn về tiến trình xóa.
      </p>
    </div>
  );
}

export default SecurityPolicy;